import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { IoArrowBackOutline } from "react-icons/io5";
import { AppContext } from "../context/AppContext";
import "../css/LegalPages.css";
import "../css/mainhome.css";

const inactiveRefundSections = [
  {
    title: "Gama567 Publications - A Book Store",
    body: [
      "Effective Date: 07 July 2026",
      "At Gama567 Publications - A Book Store, we strive to provide a smooth and transparent purchasing experience. Please read our Refund & Cancellation Policy carefully before placing an order.",
    ],
  },
  {
    title: "1. Order Cancellation",
    body: [
      "Customers may request cancellation of their order before it has been processed or completed. If the order has already been processed or delivered, cancellation may not be possible.",
    ],
  },
  {
    title: "2. Refund Eligibility",
    body: [
      "A refund may be granted if:",
      "Your order is successfully cancelled before processing.",
      "Payment was deducted but the order was not completed due to a technical issue.",
      "An eligible refund is approved by our support team.",
      "Refund requests are subject to verification.",
    ],
  },
  {
    title: "3. Refund Method",
    body: [
      "Approved refunds will be credited to your Gama567 Publications Wallet. Wallet refunds can be used for future book purchases within the application.",
    ],
  },
  {
    title: "4. Refund Processing Time",
    body: [
      "Once a refund is approved, the amount will generally be credited to your wallet within 1-7 business days, depending on verification and processing requirements.",
    ],
  },
  {
    title: "5. Order Modification",
    body: [
      "If you need to modify your order after placing it, please contact our Customer Support via WhatsApp as soon as possible with: Registered Name, Registered Mobile Number, Order ID, and Details of the requested changes. Our support team will make reasonable efforts to assist you before the order is processed.",
    ],
  },
  {
    title: "6. Wallet Policy",
    body: [
      "The Add Fund feature allows users to maintain wallet balance for fast and hassle-free checkout. Wallet funds are intended only for purchasing books within the app. Users are responsible for entering the correct amount while adding funds. Wallet transactions are recorded in the user's account.",
    ],
  },
  {
    title: "7. Non-Refundable Cases",
    body: [
      "Refunds may not be provided in the following situations:",
      "Incorrect orders placed by the customer after successful processing.",
      "Requests made after the order has been completed or delivered (unless required by applicable law).",
      "Misuse of promotional offers, coupons, or wallet services.",
      "Violation of the application's Terms & Conditions.",
    ],
  },
  {
    title: "8. Technical Issues",
    body: [
      "If payment is deducted but your order is not confirmed, please contact Customer Support immediately. After verification, eligible refunds will be credited to your wallet.",
    ],
  },
  {
    title: "9. Contact Support",
    body: [
      "For cancellation, refunds, wallet issues, or order modifications, please contact our Customer Support WhatsApp available within the Gama567 Publications application. Please keep the following information ready: Registered Name, Mobile Number, Order ID, and Payment Details (if applicable).",
    ],
  },
  {
    title: "10. Policy Updates",
    body: [
      "Gama567 Publications reserves the right to update or modify this Refund & Cancellation Policy at any time. Any changes will become effective immediately after being published in the application.",
    ],
  },
  {
    title: "Disclaimer",
    body: [
      "All books available on Gama567 Publications - A Book Store are published by Kalyanji Publications Book Store and are intended solely for educational, informational, and reference purposes.",
      "Copyright © 2026 Kalyanji Publications Book Store. All Rights Reserved.",
    ],
  },
];

export default function RefundPolicy() {
  const { isInactive } = useContext(AppContext);
  const navigate = useNavigate();

  return (
    <div className="mainhome-screen-wrapper">
      <div className="legal-header">
        <button className="legal-back-btn" onClick={() => navigate(-1)} aria-label="Go back">
          <IoArrowBackOutline size={24} />
        </button>
        <h2>{isInactive ? "Refund & Cancellation Policy" : "Refund Policy"}</h2>
      </div>
      <main className="legal-content">
        {isInactive ? (
          <>
            {inactiveRefundSections.map((section) => (
              <section className="legal-section" key={section.title}>
                <h3>{section.title}</h3>
                {section.body.map((line) => (
                  <p key={line}>{line}</p>
                ))}
              </section>
            ))}
          </>
        ) : (
          <section className="legal-section">
            <h3>Refund Policy</h3>
            <p>Refund requests for book purchases are reviewed after payment verification and order status checks.</p>
            <p>If an amount is debited but the order is not created, please contact support with your transaction details.</p>
            <p>Approved refunds are processed to the original payment method as per banking and payment gateway timelines.</p>
          </section>
        )}
      </main>
    </div>
  );
}
